export const DEFAULT_TOAST_ERROR_TITLE = 'Something went wrong';
export const DEFAULT_TOAST_ERROR_MESSAGE =
  'Please, try again. If the error persists, call your Account Management representative.';
export const DATA_MANAGEMENT_PATH = '/data-management';
export const UPLOAD_DATA_PATH = '/upload-data';
export const ANALYST_BANNER_TEXT =
  'Explore my AIRES data with the CU Data Analyst';
export const ANALYST_BANNER_PAGES = [
  '/data-management',
  '/lid-page',
  '/impact-report',
  '/demographics-page',
];
export const DATE_FORMAT_OPTIONS = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
} as Intl.DateTimeFormatOptions;
